import React from "react";
import SchedulerWidget from "./SchedulerWidget";
import "../pages/SchedulerPage.css"; // For modal styles

function DateDetailsWidget({ selectedDate, onClose, position, refreshEvents }) {
    if (!selectedDate) return null;

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div
                className="modal-content"
                style={{
                    position: "absolute",
                    top: position?.y ?? 50,
                    left: position?.x ?? 100,
                    transform: "none",
                    pointerEvents: "auto",
                }}
                onClick={(e) => e.stopPropagation()}
            >
                <SchedulerWidget
                    selectedDate={selectedDate}
                    onClose={onClose}
                    refreshEvents={refreshEvents} // ✅ fixed
                />
            </div>
        </div>
    );
}

export default DateDetailsWidget;
